import { render, staticRenderFns } from "./StoreItem.vue?vue&type=template&id=f9d34d16"
import script from "./StoreItem.vue?vue&type=script&lang=js"
export * from "./StoreItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports